<template>
  <section class="main-content">
    <MainBanner banner="Kontakt" />
    <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Startseite - ito consult GmbH",
            "item": "https://ito-consult.de"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Kontakt",
            "item": "https://ito-consult.de/kontakt"
          }
        ]
      }
    </script>
    <section class="block-content pb-5" id="formContainer">
      <div class="container my-md-5 py-md-5">
        <div
          class="content-midwide"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-offset="100"
        >
          <article v-html="contact_form_text"></article>
          <form @submit="submitForm" id="contact_form">
            <div
              class="pending align-items-center justify-content-center"
              v-if="isSending"
            >
              <svg
                version="1.1"
                width="100"
                height="100"
                id="L9"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 100 100"
                enable-background="new 0 0 0 0"
                xml:space="preserve"
              >
                <path
                  fill="#cc071e"
                  d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                >
                  <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    dur="1s"
                    from="0 50 50"
                    to="360 50 50"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-floating mb-3">
                  <input
                    type="text"
                    :class="{ 'is-invalid': form_errors.name }"
                    class="form-control border-bottom-only"
                    name="name"
                    id="name"
                    placeholder="dein Name"
                    v-model="form.name"
                  />
                  <label for="name">Name *</label>
                </div>
                <div class="form-floating mb-3">
                  <input
                    type="text"
                    class="form-control border-bottom-only"
                    name="company"
                    id="company"
                    placeholder="dein Unternehmen"
                    v-model="form.company"
                  />
                  <label for="company">Firma</label>
                </div>
                <div class="form-floating mb-3">
                  <input
                    type="email"
                    :class="{ 'is-invalid': form_errors.mail }"
                    class="form-control border-bottom-only"
                    name="mail"
                    id="email"
                    placeholder="max@msutermann.de"
                    v-model="form.mail"
                  />
                  <label for="email">E-Mail *</label>
                </div>
                <div class="form-floating mb-3">
                  <input
                    type="tel"
                    class="form-control border-bottom-only"
                    name="phone"
                    id="phone"
                    placeholder="0351 810 77 33"
                    v-model="form.phone"
                  />
                  <label for="phone">Rückrufnummer</label>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-floating mb-3 ms-md-5">
                  <textarea
                    :class="{ 'is-invalid': form_errors.message }"
                    class="form-control border-bottom-only"
                    name="message"
                    id="message"
                    style="min-height: 17.5rem; height: auto"
                    placeholder="Dein Anliegen kannst du uns hier schildern"
                    v-model="form.message"
                  ></textarea>
                  <label for="message">Anliegen *</label>
                </div>
              </div>
            </div>
            <p class="text-muted small py-3">
              Die von Ihnen übermittelten Daten speichern und verwenden wir
              ausschließlich für den Zweck, für den Ihre Angabe erfolgte.
              Weitere Informationen finden Sie in unseren
              <router-link
                :to="{ name: 'policy' }"
                target="_blank"
                class="inherit"
                >Datenschutzinformationen</router-link
              >.
            </p>
            <button
              type="submit"
              class="btn btn-outline-ito hover-red animated-arrow"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-arrow-right-short"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                /></svg
              >Anfrage absenden!
            </button>
            <div
              class="alert mt-3"
              :class="{
                'alert-success': callback.success,
                'alert-danger': !callback.success,
              }"
              v-if="callback"
              v-html="callback.message"
            ></div>
          </form>
        </div>
      </div>
    </section>

    <section class="block-content pb-5">
      <div class="container my-md-5 py-md-5">
        <div
          class="content-midwide"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-offset="100"
        >
          <article v-html="contact_map_text"></article>
        </div>
      </div>
      <div
        id="mapImageWrapper"
        class="aos-init aos-animate"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-offset="100"
      >
        <img
          rel="preload"
          src="~@/assets/gfx/map.jpg"
          title="Open Street Map"
          alt="Kartenausschnitt Dresden Klotzsche"
        />
        <span class="pin"></span>
      </div>
      <!--<MglMap id="map" data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100" :accessToken="mapData.accessToken" :mapStyle="mapData.mapStyle" @load="onMapLoaded">
          <MglMarker :coordinates="mapData.coordinates" color="#cc071e" />
        </MglMap>-->
      <div
        class="container mapcontent"
        data-aos="fade-left"
        data-aos-duration="1000"
        data-aos-offset="100"
        data-aos-delay="500"
      >
        <div
          class="
            d-flex
            h-100
            align-items-center
            justify-content-center justify-content-md-end
          "
        >
          <article>
            <address>
              <h3>ito consult GmbH</h3>
              <p>Boltenhagener Straße 140<br />01109 Dresden</p>
            </address>
            <p>
              <a href="tel:+49 351 810 77 33">Telefon: +49 351 810 77 33</a
              ><br /><a href="mailto:info@ito-consult.de"
                >E-Mail: info@ito-consult.de</a
              >
            </p>
          </article>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
// @ is an alias to /src
import store from '@/store'
import axios from 'axios'
const MainBanner = () => import('@/components/Content/MainBanner.vue')
const querystring = require('querystring')

export default {
  name: 'Contact',
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Kontakt'),
      meta: [
        {
          name: 'description',
          content: this.$parent.getDescription('Kontakt')
        },
        { property: 'og:title', content: this.$parent.getOGTitle('Kontakt') },
        {
          property: 'og:description',
          content: this.$parent.getOGDescription('Kontakt')
        }
      ]
    }
  },
  data: function () {
    return {
      form: {
        name: '',
        company: '',
        mail: '',
        phone: '',
        message: ''
      },
      form_errors: {
        name: false,
        mail: false,
        message: false
      },
      callback: null,
      isSending: false
    }
  },
  components: {
    MainBanner
  },
  mounted () {
    store.commit('loadingStatus', false)
  },
  computed: {
    contact_form_text () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter((item) => {
          return item.title.indexOf('Kontakt-Form-Text') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    contact_map_text () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter((item) => {
          return item.title.indexOf('Kontakt-Map-Text') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    }
  },
  methods: {
    submitForm (e) {
      e.preventDefault()

      // validation
      this.form_errors.name = this.form.name === ''
      this.form_errors.mail = this.form.mail === ''
      this.form_errors.message = this.form.message === ''
      if (
        this.form_errors.message ||
        this.form_errors.mail ||
        this.form_errors.name
      ) { return false }
      this.isSending = true
      axios
        .post(
          'https://ito-consult.de/mail-contact-form.php',
          querystring.stringify(this.form)
        )
        .then((res) => {
          this.callback = res.data
          if (this.callback.success) {
            document.getElementById('contact_form').reset()
            this.form.name = ''
            this.form.company = ''
            this.form.mail = ''
            this.form.phone = ''
            this.form.message = ''
          }
          this.isSending = false
        })
    }
  }
}
</script>
<style scoped>
.mapcontent a {
  color: var(--ito-red);
  text-decoration: none;
}
.inherit {
  color: inherit;
}

#mapImageWrapper {
  width: 90%;
  margin: 0 auto;
  position: relative;
  height: 300px;
  overflow: hidden;
}

#mapImageWrapper .pin {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -100%);
  background: url(~@/assets/gfx/pin.png) center center no-repeat;
  width: 40px;
  height: 62px;
  z-index: 10;
}

@media (min-width: 768px) {
  #mapImageWrapper {
    width: 60%;
    height: 400px;
    position: absolute;
  }
}

#mapImageWrapper img {
  width: 100%;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform-origin: top left;
  transform: translate(-50%, -50%);
  animation: zoomIn 5s ease-in-out 2s forwards;
}

@keyframes zoomIn {
  0% {
    transform: scale(1, 1) translate(-50%, -50%);
  }
  100% {
    transform: scale(4, 4) translate(-50%, -50%);
  }
}

form .pending {
  content: '';
  display: flex;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  background: #fff;
  z-index: 10;
  opacity: 0.5;
  position: absolute;
}
</style>
